import { DashboardProject, HealthZone } from './types';

export const PROJECT_ZONES: Record<HealthZone, string> = {
  OTHER: 'Assigned projects',
  SAFE: 'Safe',
  MONITORING: 'Monitoring',
  CRITICAL: 'Critical',
  ESCALATION: 'Escalation',
};

export const PROJECT_ZONES_ALIASES = {
  OTHER: 'OTHER',
  SAFE: 'SAFE',
  MONITORING: 'MONITORING',
  CRITICAL: 'CRITICAL',
  ESCALATION: 'ESCALATION',
};

export const PROJECT_ZONE_TEXT = {
  OTHER: '',
  SAFE: 'No challenges',
  MONITORING: 'Not critical challenges',
  CRITICAL: 'Requires immediate action',
  ESCALATION: 'Emergency intervention is required',
};

export const mainZones = [
  PROJECT_ZONES_ALIASES.ESCALATION,
  PROJECT_ZONES_ALIASES.CRITICAL,
  PROJECT_ZONES_ALIASES.MONITORING,
  PROJECT_ZONES_ALIASES.SAFE,
];

export const ZONE_PRIORITY: Record<HealthZone, number> = {
  OTHER: 1,
  SAFE: 2,
  MONITORING: 3,
  CRITICAL: 4,
  ESCALATION: 5,
};

export const HEALTH_STATUS = {
  ACTIVE: 'ACTIVE',
};

export const HEALTHCHECK_NAMES = {
  CONTRACT_RENEWAL: 'ContractRenewal',
  PROJECT_COMMERCIAL_STATE: 'ProjectCommercialState',
  PROJECT_COMMERCIAL_STATE_STATUS: 'ProjectCommercialStateStatus',
  STAKEHOLDERS: 'Stakeholders',
  ASSUMPTIONS: 'Assumptions',
  BILLING: 'BillingSchedule',
  RISKS: 'Risks',
  COMMERCIAL_RISKS: 'CommercialRisks',
  ENGINEERING_RISKS: 'EngineeringRisks',
  STAFFING_RISKS: 'StaffingRisks',
  PROJECT_MANAGEMENT_RISKS: 'ProjectManagementRisks',
  BUDGET_STATE: 'BudgetState',
  PROGRESS_DATE: 'ProgressForecastDate',
  PROGRESS_VALUE: 'ProgressForecastValue',
  BUDGET_FORECAST_DATE: 'BudgetForecastDate',
  BUDGET_FORECAST_VALUE: 'BudgetForecastValue',
  TIMELINE_DATE: 'TimelineForecastDate',
  TIMELINE_VALUE: 'TimelineForecastValue',
  PPC: 'PPC',
  ENGINEERING_BUGS: 'EngineeringBugsValue',
  ENGINEERING_INCIDENTS: 'EngineeringIncidentsValue',
  ENGINEERING_SETUP: 'EngineeringSetup',
  ENGINEERING_LINK: 'EngineeringLink',
  BUSINESS_OUTCOMES: 'BusinessOutcomes',
  MILESTONES: 'Milestones',
  CUSTOMER_REPORT: 'CustomerReport',
  CHANGE_REQUESTS: 'ChangeRequests',
  PROJECT_UNDERSTAFFED: 'PROJECT_UNDERSTAFFED',
  KEY_ROLE_UNSTAFFED: 'KEY_ROLE_UNSTAFFED',
  TEAM_QUALITY_MISMATCH: 'TEAM_QUALITY_MISMATCH',
  TEAM_MEMBERSHIP_ENDING_SOON: 'TEAM_MEMBERSHIP_ENDING_SOON',
  REPLACEMENT_NOT_ASSIGNED: 'REPLACEMENT_NOT_ASSIGNED',
};

export const ZONE_MAPPING: Record<string, HealthZone> = {
  SAFE: 'SAFE',
  MONITORING: 'MONITORING',
  RISK: 'CRITICAL',
  ESCALATION: 'ESCALATION',
  OTHER: 'OTHER',
};

export const recalculateAccountHealthZone = (currentZone: HealthZone, project: DashboardProject): HealthZone => {
  const newProjectZone = project.projectHealthZone;
  if (ZONE_PRIORITY[newProjectZone] > ZONE_PRIORITY[currentZone]) {
    return newProjectZone;
  }

  return currentZone;
};
